<script>
export default {
  props: {
    label: {
      type: String,
      default: null,
    },
    id: {
      type: [String, Number],
      required: true,
    },
    type: {
      type: String,
      default: "text",
    },
    placeholder: {
      type: String,
      default: null,
    },
    modelValue: {
      type: [String, Number],
      default: "",
    },
    required: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxlenght: {
      type: Number,
      default: null,
    },
    minlenght: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<template>
  <div class="w-full">
    <label v-if="label" :for="id" class="block mb-2 text-lightGrey text-sm font-bold">{{ label }}</label>
    <input :id="id" :value="modelValue" :type="type" :placeholder="placeholder || label"
      class="w-full py-2 px-3 appearance-none border rounded text-lightGrey leading-tight outline-none focus:border focus:border-solid focus:border-airbnbRed focus:shadow placeholder-gray-500"
      :class="{ 'cursor-not-allowed': disabled }" :disabled="disabled" :required="required"
      :minlength="minlenght === 0 ? (type === 'password' ? 8 : 0) : minlenght" :maxlength="maxlenght"
      @input="$emit('update:modelValue', $event.target.value)" @focus="$emit('focus')" @blur="$emit('blur')" />
  </div>
</template>
